document.addEventListener('DOMContentLoaded', function () {

  const builders = document.querySelectorAll('[data-bundle-builder]');

  if (!builders.length) return;


  builders.forEach(function (builder) {

    const bundleLimit = Number(builder.dataset.bundleLimit);

    const products = builder.querySelectorAll('.bundle-product');

    const notification =
      builder.querySelector('.bundle-notification');


    /* =========================================
       VALIDATE BUNDLE LIMIT
    ========================================== */

    if (!bundleLimit || bundleLimit <= 0) {

      console.error(
        'Mix Match Bundle: Bundle limit is missing or invalid.'
      );

      return;
    }


    /* =========================================
       GET TOTAL SELECTED
    ========================================== */

    function getTotal() {

      let total = 0;

      products.forEach(function (product) {

        const countElement =
          product.querySelector('.bundle-count');

        if (!countElement) return;

        total += Number(countElement.textContent) || 0;

      });

      return total;
    }


    /* =========================================
       SHOW NOTIFICATION
    ========================================== */

    function showNotification(message) {

      if (!notification) return;

      notification.textContent = message;

      notification.classList.add('show');

      clearTimeout(notification.hideTimer);

      notification.hideTimer = setTimeout(function () {

        notification.classList.remove('show');

      }, 4000);

    }


    /* =========================================
       HIDE NOTIFICATION
    ========================================== */

    function hideNotification() {

      if (!notification) return;

      notification.textContent = '';

      notification.classList.remove('show');

    }


    /* =========================================
       UPDATE BUTTONS
    ========================================== */

    function updateButtons() {

      const total = getTotal();

      products.forEach(function (product) {

        const countElement =
          product.querySelector('.bundle-count');

        const minusButton =
          product.querySelector('.bundle-minus');

        const plusButton =
          product.querySelector('.bundle-plus');

        if (
          !countElement ||
          !minusButton ||
          !plusButton
        ) {
          return;
        }

        const quantity =
          Number(countElement.textContent) || 0;


        /* Minus disabled at zero */

        minusButton.disabled =
          quantity <= 0;


        /* Plus stays clickable */

        plusButton.disabled = false;


        if (total >= bundleLimit) {

          plusButton.setAttribute(
            'data-limit-reached',
            'true'
          );

        } else {

          plusButton.removeAttribute(
            'data-limit-reached'
          );

        }

      });

    }


    /* =========================================
       RESET BUNDLE
    ========================================== */

    function resetBundle() {

      products.forEach(function (product) {

        const countElement =
          product.querySelector('.bundle-count');

        if (!countElement) return;

        countElement.textContent = '0';

      });

      updateButtons();

      hideNotification();

    }


    /* =========================================
       PLUS / MINUS
    ========================================== */

    products.forEach(function (product) {

      const plusButton =
        product.querySelector('.bundle-plus');

      const minusButton =
        product.querySelector('.bundle-minus');

      const countElement =
        product.querySelector('.bundle-count');


      if (
        !plusButton ||
        !minusButton ||
        !countElement
      ) {
        return;
      }


      /* =========================================
         PLUS
      ========================================== */

      plusButton.addEventListener('click', function (event) {

        event.preventDefault();
        event.stopPropagation();

        const total = getTotal();


        if (total >= bundleLimit) {

          showNotification(
            'You can only select up to ' +
            bundleLimit +
            ' items for this pack.'
          );

          return;
        }


        const currentQuantity =
          Number(countElement.textContent) || 0;


        countElement.textContent =
          currentQuantity + 1;


        hideNotification();

        updateButtons();

      });


      /* =========================================
         MINUS
      ========================================== */

      minusButton.addEventListener('click', function (event) {

        event.preventDefault();
        event.stopPropagation();

        const currentQuantity =
          Number(countElement.textContent) || 0;


        if (currentQuantity <= 0) {
          return;
        }


        countElement.textContent =
          currentQuantity - 1;


        hideNotification();

        updateButtons();

      });

    });


    /* =========================================
       FIND PRODUCT FORM
    ========================================== */

    const productForm =
      builder.closest(
        'section, .shopify-section, main'
      )?.querySelector(
        'form[action*="/cart/add"]'
      ) ||
      document.querySelector(
        'form[action*="/cart/add"]'
      );


    if (!productForm) {

      console.error(
        'Mix Match Bundle: Product form not found.'
      );

      showNotification(
        'Product form could not be found.'
      );

      return;
    }


    /* =========================================
       GET SELECTED VARIATIONS
    ========================================== */

    function getSelectedProducts() {

      const selectedProducts = [];

      products.forEach(function (product) {

        const countElement =
          product.querySelector('.bundle-count');

        if (!countElement) return;


        const quantity =
          Number(countElement.textContent) || 0;


        if (quantity <= 0) return;


        /*
         * IMPORTANT:
         * Each .bundle-product must have:
         *
         * data-variant-id="VARIANT_ID"
         */

        const variantId =
          Number(product.dataset.variantId);


        const nameElement =
          product.querySelector(
            '.bundle-product-name'
          );


        const productName =
          nameElement
            ? nameElement.textContent.trim()
            : 'Product';


        if (!variantId) {

          console.error(
            'Missing variant ID for:',
            productName
          );

          return;
        }


        selectedProducts.push({

          id: variantId,

          quantity: quantity,

          name: productName

        });

      });


      return selectedProducts;

    }


    /* =========================================
       ADD BUNDLE TO CART
    ========================================== */

    async function addBundleToCart(event) {

      if (event) {

        event.preventDefault();
        event.stopPropagation();

        if (
          typeof event.stopImmediatePropagation ===
          'function'
        ) {

          event.stopImmediatePropagation();

        }

      }


      /* =========================================
         PREVENT DOUBLE CLICK
      ========================================== */

      if (
        builder.dataset.adding === 'true'
      ) {

        return;

      }


      /* =========================================
         CHECK TOTAL
      ========================================== */

      const total = getTotal();


      if (total < bundleLimit) {

        showNotification(
          'Please select exactly ' +
          bundleLimit +
          ' items for this pack. You have selected ' +
          total +
          '.'
        );

        return;

      }


      if (total > bundleLimit) {

        showNotification(
          'You can only select exactly ' +
          bundleLimit +
          ' items for this pack.'
        );

        return;

      }


      /* =========================================
         GET SELECTED VARIATIONS
      ========================================== */

      const selectedProducts =
        getSelectedProducts();


      if (!selectedProducts.length) {

        showNotification(
          'Please select your bundle items.'
        );

        return;

      }


      /* =========================================
         VERIFY TOTAL
      ========================================== */

      const selectedTotal =
        selectedProducts.reduce(
          function (sum, item) {

            return sum + item.quantity;

          },
          0
        );


      if (selectedTotal !== bundleLimit) {

        showNotification(
          'Please select exactly ' +
          bundleLimit +
          ' items for this pack.'
        );

        return;

      }


      /* =========================================
         CREATE BUNDLE SELECTION TEXT
      ========================================== */

      const bundleSelection =
        selectedProducts
          .map(function (item) {

            return (
              item.name +
              ' × ' +
              item.quantity
            );

          })
          .join(', ');


      /*
       * Example:
       *
       * The Pope × 4, Truth or Dare × 2
       */


      /* =========================================
         CREATE SEPARATE CART LINES
      ========================================== */

      const cartItems =
        selectedProducts.map(function (item) {

          return {

            /*
             * REAL SHOPIFY VARIANT ID
             */

            id: item.id,


            /*
             * EXACT SELECTED QUANTITY
             */

            quantity: item.quantity,


            /*
             * SAME BUNDLE INFORMATION
             * ON EVERY VARIANT
             */

            properties: {

              'Bundle Type':
                bundleLimit + ' Pack',

              'Bundle Selection':
                bundleSelection

            }

          };

        });


      console.log(
        'ROMA Bundle Cart Items:',
        cartItems
      );


      /* =========================================
         LOCK ADD TO CART
      ========================================== */

      builder.dataset.adding = 'true';


      const addToCartButtons =
        productForm.querySelectorAll(
          'button[type="submit"], input[type="submit"]'
        );


      addToCartButtons.forEach(function (button) {

        button.disabled = true;

        button.setAttribute(
          'aria-disabled',
          'true'
        );

      });


      /* =========================================
         ADD ALL VARIANTS
         AS SEPARATE CART LINES
      ========================================== */

      try {

        const response =
          await fetch(
            '/cart/add.js',
            {

              method: 'POST',

              headers: {

                'Content-Type':
                  'application/json',

                'Accept':
                  'application/json'

              },

              body: JSON.stringify({

                items: cartItems

              })

            }
          );


        const data =
          await response.json();


        /* =========================================
           ERROR
        ========================================== */

        if (!response.ok) {

          throw new Error(

            data.description ||
            data.message ||
            'Unable to add bundle to cart.'

          );

        }


        console.log(
          'ROMA Bundle Added:',
          data
        );


        /* =========================================
           RESET COUNTERS
           ONLY AFTER SUCCESS
        ========================================== */

        resetBundle();


        /* =========================================
           GET UPDATED CART
        ========================================== */

        const cartResponse =
          await fetch(
            '/cart.js',
            {

              method: 'GET',

              headers: {

                'Accept':
                  'application/json'

              }

            }
          );


        const cart =
          await cartResponse.json();


        console.log(
          'Updated Cart:',
          cart
        );


        /* =========================================
           CART EVENTS
        ========================================== */

        document.dispatchEvent(
          new CustomEvent(
            'cart:refresh',
            {
              bubbles: true,

              detail: {
                cart: cart
              }
            }
          )
        );


        document.dispatchEvent(
          new CustomEvent(
            'cart:updated',
            {
              bubbles: true,

              detail: {
                cart: cart
              }
            }
          )
        );


        window.dispatchEvent(
          new CustomEvent(
            'cart:refresh',
            {
              detail: {
                cart: cart
              }
            }
          )
        );


        /* =========================================
           REFRESH SHOPIFY CART DRAWER
        ========================================== */

        const cartDrawer =
          document.querySelector(
            'cart-drawer'
          );


        if (cartDrawer) {

          /*
           * If theme supports renderContents,
           * refresh its contents.
           */

          if (
            typeof cartDrawer.renderContents ===
              'function'
          ) {

            /*
             * We don't rely only on
             * data.sections because
             * different Shopify themes
             * handle drawer rendering differently.
             */

            try {

              if (data.sections) {

                cartDrawer.renderContents(data);

              }

            } catch (drawerRenderError) {

              console.warn(
                'Cart drawer renderContents failed:',
                drawerRenderError
              );

            }

          }


          /* =========================================
             OPEN DRAWER
          ========================================== */

          if (
            typeof cartDrawer.open ===
              'function'
          ) {

            cartDrawer.open();

          }

        }


        /* =========================================
           FALLBACK DRAWER
        ========================================== */

        const drawer =
          document.querySelector(
            '#CartDrawer'
          );


        if (
          drawer &&
          typeof drawer.open ===
            'function'
        ) {

          drawer.open();

        }


        /* =========================================
           CART OPEN EVENT
        ========================================== */

        document.dispatchEvent(
          new CustomEvent(
            'cart:open',
            {
              bubbles: true,

              detail: {
                cart: cart
              }
            }
          )
        );


        hideNotification();


      } catch (error) {

        console.error(
          'Mix Match Bundle Error:',
          error
        );


        showNotification(
          error.message ||
          'Something went wrong. Please try again.'
        );

      }


      /* =========================================
         UNLOCK ADD TO CART
      ========================================== */

      addToCartButtons.forEach(function (button) {

        button.disabled = false;

        button.removeAttribute(
          'aria-disabled'
        );

      });


      builder.dataset.adding = 'false';

    }


    /* =========================================
       INTERCEPT FORM SUBMIT
    ========================================== */

    productForm.addEventListener(
      'submit',
      function (event) {

        addBundleToCart(event);

      },
      true
    );


    /* =========================================
       INTERCEPT ADD TO CART BUTTON
    ========================================== */

    const submitButtons =
      productForm.querySelectorAll(
        'button[type="submit"], input[type="submit"]'
      );


    submitButtons.forEach(function (button) {

      button.addEventListener(
        'click',
        function (event) {

          addBundleToCart(event);

        },
        true
      );

    });


    /* =========================================
       INITIALIZE
    ========================================== */

    updateButtons();

  });

});